import { MouseEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Spinner, StandAloneLink, Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import ExplicitInformedConsent from '@app/components/ExplicitInformedConsent';
import { selectAddOns, setDisclosureChecked } from '@app/redux/addOns';

import { ProductType } from '@mfe/shared/schema-types';

import Footer from '../Footer';

import styles from '../../styles/disclosure-page.module.scss';

interface LeftContentProps {
  handleBack?: () => void;
  handleContinue: () => void;
  addon: ProductType | null;
  submitButtonLabel?: string;
  consentRef?: React.RefObject<HTMLInputElement>;
}

const DisclosureContent = ({ handleBack, handleContinue, addon, submitButtonLabel, consentRef }: LeftContentProps) => {
  const { t } = useTranslation('ShopAddons');
  const dispatch = useDispatch();
  const { eicMessage, configureAddonLoading, eicChecked, isErrorDisclosureChecked, eicMessageLoading } =
    useSelector(selectAddOns);

  if (eicMessageLoading || configureAddonLoading) {
    return (
      <div className={styles['wrapper']}>
        <div className={styles['spinnerWrapper']}>
          <Spinner description={t('loading.disclosures')} />
        </div>
      </div>
    );
  }

  return (
    <>
      <Surface className={styles['leftCardContent']}>
        <div>
          <Txt variant={'bodyLargeBold'} mb={'40px'}>
            {t('disclosure.subtitle')}
          </Txt>
          <hr className={styles.divider} />
        </div>
        <Txt variant="bodyLargeBold" mt={'16px'} mb={'4px'}>
          {addon?.name}
        </Txt>
        <ExplicitInformedConsent
          id={'checkbox'}
          label={`${t('disclosure.checkbox.label')}`}
          isChecked={eicChecked}
          onChange={() => dispatch(setDisclosureChecked(!eicChecked))}
          hasError={isErrorDisclosureChecked}
          errorMessage={`${t('disclosure.checkbox.errorMessage')}`}
          disclosureText={eicMessage ? eicMessage.eicMessage : []}
          consentRef={consentRef}
        />
      </Surface>
      <Footer>
        <StandAloneLink
          variant={'primary'}
          linkSize={'medium'}
          href={'#'}
          data-cy="navigatorBackLink"
          onClick={(e: MouseEvent<HTMLElement>) => {
            handleBack?.();
            e.preventDefault();
          }}
        >
          {t('goBack')}
        </StandAloneLink>
        <Button variant="primary" onClick={handleContinue}>
          {submitButtonLabel}
        </Button>
      </Footer>
    </>
  );
};

export default DisclosureContent;
